<template>
  <div class="page" ref="container">
    <nav-bar
      title="充值记录"
      left-text="返回"
      left-arrow
      @click-left="goBack"
      :fixed="false"
      :placeholder="true"
    />

    <div class="recharge-record">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div
          class="list acea-row row-between-wrapper"
          @click="$router.push({ path: `/order/detail/${item.id}` })"
        >
          <div>
            <div class="name line1">
              {{ item.items ? "套餐充次" : "现金充值" }}
            </div>
            <div>{{ formatDate(item.createTime) }}</div>
          </div>
          <div class="num" :class="item.items ? '' : 'font-color-red'">
            {{ item.realAmount }}
          </div>
        </div>
      </div>
      <empty
        description="暂无预约信息~"
        v-if="list.length === 0 && where.page > 1"
      />
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { NavBar, Empty } from "vant";
import { getRecharge } from "@api/member";
import Loading from "@components/Loading";
import dayjs from "dayjs";
import { mapGetters } from "vuex";
export default {
  name: "UserBill",
  components: {
    Loading,
    NavBar,
    Empty,
  },
  props: {},
  data: function () {
    return {
      types: "",
      where: {
        page: 1,
        limit: 5,
      },
      list: [],
      loaded: false,
      loading: false,
    };
  },
  computed: mapGetters(["userInfo"]),
  watch: {
    userInfo: {
      handler(val, oldVal) {
        this.getIndex();
      },
    },
  },
  mounted: function () {
    let that = this;
    that.getIndex();
    that.$scroll(that.$refs.container, () => {
      !that.loading && that.getIndex();
    });
  },
  methods: {
    formatDate(time) {
      return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
    },
    getIndex: function () {
      let that = this;
      if (that.loaded == true || that.loading == true) return;
      that.loading = true;
      getRecharge(that.where).then((res) => {
        that.loading = false;
        that.loaded = res.result.total < that.where.limit;
        that.where.page = that.where.page + 1;
        that.list.push.apply(that.list, res.result.records);
        console.info(res);
      });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  .item {
    background-color: #fff;
    font-size: 0.24rem;
    color: #999;
    margin: 5px 0;

    .list {
      height: 60px;
      border-bottom: 0.5px solid #eee;
      padding-right: 15px;
      margin-left: 15px;
      .name {
        width: 195px;
        font-size: 14px;
        color: #282828;
        margin-bottom: 5px;
      }
      .num {
        font-size: 18px;
        font-family: Guildford Pro;
        color: #16ac57;
      }
    }
  }
}
</style>
